/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum DashboardTemperatureHandling {
  KeepFrozen = "KeepFrozen",
  KeepRefrigerated = "KeepRefrigerated",
  ProtectFromFreezing = "ProtectFromFreezing",
  NoSpecialHandling = "NoSpecialHandling",
}

export function instanceOfDashboardTemperatureHandling(value: any): boolean {
  for (const key in DashboardTemperatureHandling) {
    if (
      Object.prototype.hasOwnProperty.call(DashboardTemperatureHandling, key)
    ) {
      if (
        DashboardTemperatureHandling[
          key as keyof typeof DashboardTemperatureHandling
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function DashboardTemperatureHandlingFromJSON(
  json: any,
): DashboardTemperatureHandling {
  return DashboardTemperatureHandlingFromJSONTyped(json, false);
}

export function DashboardTemperatureHandlingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardTemperatureHandling {
  return json as DashboardTemperatureHandling;
}

export function DashboardTemperatureHandlingToJSON(
  value?: DashboardTemperatureHandling | null,
): any {
  return value as any;
}

export function DashboardTemperatureHandlingToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DashboardTemperatureHandling {
  return value as DashboardTemperatureHandling;
}
